import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const resetPasswordUrl = `${process.env.REACT_APP_ONE_MENU_URL}/reset_password`;

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        当社サービスへの招待、およびパスワードリセット後の新パスワード設定に使用するURLの有効期限は、いずれも2週間です。下記よりパスワードをリセットしていただき、新しく届いたメールに記載されているURLから設定をお願いします。
        <br />
        パスワードリセット：
        <a
          className={styles.link}
          href={resetPasswordUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {resetPasswordUrl}
        </a>
      </p>
    </div>
  </div>
);

export const EXPIRED_INVITATION_LINK_FAQ: FaqCategoryItem = {
  id: "expired-invitation-link-faq",
  question:
    "招待メールのURLから先生画面にログインしようとしたら、「有効期限が切れています」と表示される",
  Answer,
};
